<template>
  <div>
    <h3 class="v-heading" v-if="listTitle">{{ listTitle }}</h3>
    <ul class="v-list">
      <li
        class="v-listitem"
        v-for="(l) in list"
        :key="l.index"
      >
        <button type="button"
          :class="[ 'v-filterButton', selectedList.includes(l.value) ? 'is-selected' : '' ]"
          @click="$emit('itemClick', $event, l.value)"
           data-ga-event-name="collection_filter_button" data-ga-event-area="filter_list" :data-ga-event-value="l.text"
        >
          <span class="v-filterButton__inner">{{ l.text }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FilterList',

  props: {
    // [ { text: "Text", value: "text" } ]
    list: {
      type: Array,
      required: true,
    },
    selectedList: {
      type: Array,
      required: true,
    },
    listTitle: {
      type: String,
      default: ""
    },
  },
}
</script>

<style lang="scss" scoped>
.v-heading {
  font-size: 10px;
}

.v-list {
  font-size: 10px;
  display: flex;
  flex-wrap: wrap;
}

.v-filterButton {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: 0;
  letter-spacing: inherit;
  text-align: inherit;

//  margin: 0 8px 8px 0;
  padding: 6px 10px;
  color: #a3a3a3;
  
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner {
    position: relative;
    border-radius: 2px;
    display: block;
    padding: 2px 4px;
  }

  &.is-selected &__inner {
    color: #333;
    background: #e8e8e8;
  }

  &:hover &__inner {
    color: #333;
    background: #f1f1f1;
  }


}
</style>
